<list-view [liste]="geographieService.listeZones" *ngIf="geographieService.listeZones"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>